import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// config
import { PATH_BEFORE_LOGIN } from 'src/config-global';

import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';

// 404
const NotFoundPage = lazy(() => import('src/pages/404'));

export default function Router() {
  return useRoutes([
    // before login route
    {
      path: '/',
      children: [{ element: <Navigate to={PATH_BEFORE_LOGIN} replace />, index: true }],
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
    { path: '404', element: <NotFoundPage /> },
  ]);
}
